import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { CasoDto } from '@models/caso/casoDto.model';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-caso-detail-card',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatChipsModule,
    MatTooltipModule
  ],
  template: `
    <mat-card class="caso-card-simple" *ngIf="caso">

      <!-- Línea 1: Carátula + Estado + Activo -->
      <div class="linea-uno">
        <div class="caratula-section">
          <mat-icon class="caso-icon">gavel</mat-icon>
          <span class="caratula-text">{{ caso.caratula  | uppercase}}</span>
        </div>

        <div class="badges-section">
          <mat-chip class="chip-small" matTooltip="Estado del caso" [class]="getEstadoClass(caso.estadoCaso?.descripcion)">
            {{ caso.estadoCaso?.descripcion || 'Sin estado' }}
          </mat-chip>
          <mat-chip class="chip-small" [class]="caso.activo ? 'activo' : 'inactivo'">
            {{ caso.activo ? 'Activo' : 'Inactivo' }}
          </mat-chip>
        </div>
      </div>

      <!-- Línea 2: Empresa + Tipo + Fechas -->
      <div class="linea-dos">
        <div class="info-items">
          <div class="info-item" *ngIf="caso.tipoCaso?.descripcion">
            <mat-icon class="info-icon" matTooltip="Tipo de caso">category</mat-icon>
            <span>{{ caso.tipoCaso.descripcion }}</span>
          </div>

          <div class="info-item">
            <mat-icon class="info-icon">schedule</mat-icon>
            <span>{{ formatDateRange() }}</span>
          </div>
        </div>
      </div>

    </mat-card>

    <!-- Card vacía -->
    <mat-card class="caso-card-empty" *ngIf="!caso">
      <div class="empty-content">
        <mat-icon>info_outline</mat-icon>
        <span>Seleccione un caso para ver detalles</span>
      </div>
    </mat-card>
  `,
  styleUrl: './caso-detail-card.component.css'
})
export class CasoDetailCardComponent {
  @Input() caso: CasoDto | null = null;

  formatDateRange(): string {
    if (!this.caso?.fechaComienzo) return 'Sin fecha';

    const inicio = new Date(this.caso.fechaComienzo);
    const inicioStr = inicio.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: '2-digit' });

    if (this.caso.fechaFinalizacion) {
      const fin = new Date(this.caso.fechaFinalizacion);
      const finStr = fin.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: '2-digit' });
      return `${inicioStr} - ${finStr}`;
    }

    return `Desde ${inicioStr}`;
  }

  getEstadoClass(estado: string): string {
    if (!estado) return 'estado-default';

    switch (estado.toLowerCase()) {
      case 'activo':
      case 'abierto':
        return 'estado-activo';
      case 'cerrado':
      case 'finalizado':
        return 'estado-cerrado';
      case 'suspendido':
      case 'pausado':
        return 'estado-suspendido';
      default:
        return 'estado-default';
    }
  }
}
